import UserSubject from "../user_subject";
// const { NotificationManager } = require("react-notifications");

import { axios } from "../../utils/axios";

const findSubject = (subjects: any, subjectID: string) =>
    subjects.filter((subject: any) => subject._id == subjectID)[0];
const forceLogout = (err: any) =>
    err.response && err.response.data && err.response.data.forceLogout;


function userSubjectsFromResponse(res: any): Map<string, UserSubject> {
  const toUserSubjectEntry = ([k, userSubject]: [string, any]): [
    string,
    UserSubject,
  ] => {
    const subject = findSubject(res.subject_info, userSubject.subjectID);
    return [k, new UserSubject(k, userSubject, subject)];
  };

  const entries = Object.entries(res.user_subject_info).map(toUserSubjectEntry);
  return new Map(entries);
}

export function fetchSubjectsAction(store: any, cb: Function) {
    var state;

    axios()
        .get("/profile/subjects")
        .then((res: any) => res.data)
        .then((res: any) => {
            let user_subjects = userSubjectsFromResponse(res);
            cb(user_subjects, "done");
        })
        .catch((err: any) => {
            if (!err) return;

            // NotificationManager.warning(
            //     "Click to Dismiss",
            //     `There was a problem retrieving subjects. ${err}`,
            //     5000
            // );

            if (forceLogout(err)) {
                store.rootStore.profileStore.logout(function() {
                    store.rootStore.uiStore.setFlash(
                        "Sorry, your session has expired"
                    );
                    window.location.replace("/");
                });
            }

            state = "error";
            return cb(undefined, "error");
        });
}
